import React, { useEffect, useState } from "react";
import ApprovePopup from "./ApprovePopup";
import { AiOutlineNodeExpand } from "react-icons/ai";
import axios from "axios";
import { FallingLines } from "react-loader-spinner";
import { LuPanelLeftOpen, LuPanelRightOpen } from "react-icons/lu";
import { base_url } from "../../../utils/AxiosConfig";
import { FaSearch } from 'react-icons/fa';


const LeaveApproval = () => {


  const storedUserDataArray = JSON.parse(localStorage.getItem("BondTimeuserDataArray")) || [];
        let companyCode = null

        if (storedUserDataArray) {
          companyCode = storedUserDataArray[0].cmpcode
        }

  const [Open, setOpen] = useState(false);
  const [DataPending, setDataPending] = useState();
  const [DataApproved, setDataApproved] = useState();
  const [DataRejected, setDataRejected] = useState();
  const [PopUpData, setPopUpData] = useState();
  const [SearchData, setSearchData] = useState();
  const [SearchDataApproved, setSearchDataApproved] = useState();
  const [SearchDataRejected, setSearchDataRejected] = useState();
  const [loader, setLoader] = useState(true);
  const [reloadapiData, setReloadApi] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);

  // pagination
  const [currentPage, SetcurrentPage] = useState(1);
  const [currentPageApproved, SetcurrentPageApproved] = useState(1);
  const [currentPageRejected, SetcurrentPageRejected] = useState(1);
  const recordsPerPage = 10;


  const lastIndex = currentPage * recordsPerPage;
  const firstIndex = lastIndex - recordsPerPage;

  const lastIndexApproved = currentPageApproved * recordsPerPage;
  const firstIndexApproved = lastIndexApproved - recordsPerPage;

  const lastIndexRejected = currentPageRejected * recordsPerPage;
  const firstIndexRejected = lastIndexRejected - recordsPerPage;


  const dataPendingrecords = DataPending?.slice(firstIndex, lastIndex);
  const dataApprovedrecords = DataApproved?.slice(firstIndexApproved, lastIndexApproved);
  const dataRejectedrecords = DataRejected?.slice(firstIndexRejected, lastIndexRejected);


  const npage = Math.ceil(DataPending?.length / recordsPerPage);
  const npageApproved = Math.ceil(DataApproved?.length / recordsPerPage);
  const npageRejected = Math.ceil(DataRejected?.length / recordsPerPage);


  const numbers = Array.from({ length:npage }, (_, i) => i + 1);
  const numbersApproved = Array.from({ length:npageApproved }, (_, i) => i + 1);
  const numbersRejected = Array.from({ length:npageRejected }, (_, i) => i + 1);


  useEffect(() => {
    if (DataPending && DataApproved === null) {
      setLoader(true);
    } else if (DataRejected && DataPending && DataApproved) {
      setLoader(false);
    }
  }, [DataPending, DataApproved, DataRejected]);
  useEffect(() => {
    const getDataPending = async () => {
      const response = await axios.get(
        `${base_url}/api/PersonalInfoLeaveApplicationList/${companyCode}/PENDING/-`
      );
      if (response?.data) {
        setDataPending(response.data);
      } else {
        console.log("error");
      }
    };

    getDataPending();
  }, []);

  useEffect(() => {
    const getDataApproved = async () => {
      const response = await axios.get(
        `${base_url}/api/PersonalInfoLeaveApplicationList/${companyCode}/APPROVED/-`
      );
      if (response?.data) {
        setDataApproved(response.data);
      } else {
        console.log("error");
      }
    };

    getDataApproved();
  }, []);

  useEffect(() => {
    const getDataRejected = async () => {
      const response = await axios.get(
        `${base_url}/api/PersonalInfoLeaveApplicationList/${companyCode}/REJECTED/-`
      );
      if (response?.data) {
        setDataRejected(response.data);
      } else {
        console.log("error");
      }
    };

    getDataRejected();
  }, []);

  useEffect(() => {
    const getSearch = async () => {
      const response = await axios.get(
        `${base_url}/api/PersonalInfoLeaveApplicationList/${companyCode}/PENDING/${
          SearchData ? SearchData : "-"
        }`
      );
      if (response?.data) {
        setDataPending(response.data);
      } else {
        console.log("error");
      }
    };

    getSearch();
  }, [SearchData]);

  useEffect(() => {
    const getSearchDataApproved = async () => {
      const response = await axios.get(
        `${base_url}/api/PersonalInfoLeaveApplicationList/${companyCode}/APPROVED/${
          SearchDataApproved ? SearchDataApproved : "-"
        }`
      );
      if (response?.data) {
        setDataApproved(response.data);
      } else {
        console.log("error");
      }
    };

    getSearchDataApproved();
  }, [SearchDataApproved]);

  useEffect(() => {
    const getSearchDataRejected = async () => {
      const response = await axios.get(
        `${base_url}/api/PersonalInfoLeaveApplicationList/${companyCode}/REJECTED/${
          SearchDataRejected ? SearchDataRejected : "-"
        }`
      );
      if (response?.data) {
        setDataRejected(response.data);
      } else {
        console.log("error");
      }
    };

    getSearchDataRejected();
  }, [SearchDataRejected]);

  const reloadApi = (status) => {
    setReloadApi(status);
  };

  useEffect(() => {
    const getDataPending = async () => {
      const response = await axios.get(
        `${base_url}/api/PersonalInfoLeaveApplicationList/${companyCode}/PENDING/-`
      );
      if (response?.data) {
        setDataPending(response.data);
        setReloadApi(false)
      } else {
        console.log("error");
      }
    };
if(reloadapiData && SearchData===null){
  getDataPending();
}
    
  }, [reloadapiData]);

  useEffect(() => {
    const getDataApproved = async () => {
      const response = await axios.get(
        `${base_url}/api/PersonalInfoLeaveApplicationList/${companyCode}/APPROVED/-`
      );
      if (response?.data) {
        setDataApproved(response.data);
      } else {
        console.log("error");
      }
    };

    if(reloadapiData && SearchDataApproved===null){
      getDataApproved();
    }
   
  }, [reloadapiData]);

  useEffect(() => {
    const getDataRejected = async () => {
      const response = await axios.get(
        `${base_url}/api/PersonalInfoLeaveApplicationList/${companyCode}/REJECTED/-`
      );
      if (response?.data) {
        setDataRejected(response.data);
      } else {
        console.log("error");
      }
    };
if(reloadapiData&& SearchDataRejected===null){
  getDataRejected();
}
   
  }, [reloadapiData]);

  useEffect(() => {
    const getDataPending = async () => {
      const response = await axios.get(
        `${base_url}/api/PersonalInfoLeaveApplicationList/${companyCode}/PENDING/-`
      );
      if (response?.data) {
        setDataPending(response.data);
        setReloadApi(false)
      } else {
        console.log("error");
      }
    };
if(reloadapiData){
  getDataPending();
}
    
  }, [reloadapiData]);

  useEffect(() => {
    const getDataApproved = async () => {
      const response = await axios.get(
        `${base_url}/api/PersonalInfoLeaveApplicationList/${companyCode}/APPROVED/-`
      );
      if (response?.data) {
        setDataApproved(response.data);
      } else {
        console.log("error");
      }
    };

    if(reloadapiData){
      getDataApproved();
    }
   
  }, [reloadapiData]);

  useEffect(() => {
    const getDataRejected = async () => {
      const response = await axios.get(
        `${base_url}/api/PersonalInfoLeaveApplicationList/${companyCode}/REJECTED/-`
      );
      if (response?.data) {
        setDataRejected(response.data);
      } else {
        console.log("error");
      }
    };
if(reloadapiData){
  getDataRejected();
}
   
  }, [reloadapiData]);

  // console.log('reloadapiData',reloadapiData)
  console.log('DataApproved',DataApproved)

  return (
    <div className="container">
      <div
        className={
          Open ? "leave-allotment container-fluid ps-2" : "container-fluid ps-2"
        }
      >
        <div className="flex items-center justify-between mb-4">
          <div className="">
            {/* <h6 className="head-text">Leave Approval</h6> */}
                        <h6 className=" text-2xl font-bold text-gray-600 flex  justify-start items-center">
                          Leave Approval</h6> 

          </div>
          <div className="">
          {Open===true ?<>< LuPanelRightOpen onClick={()=>setOpen(false)}/></>:null}
    {Open===false ?<><LuPanelLeftOpen onClick={()=>setOpen(true)}/></>:null}
            
          </div>
        </div>
        {dataPendingrecords ? (
          <>
            <div>
              <div className="leave-application-table mt-2">
                <p className="fs-small text-secondary mb-2">
                  Leave Request For Approval
                </p>
                <div className="row">
                  <div className="col-3">

                  <div className="EmpList-search-container">
                    <FaSearch className="EmpList-search-icon" />
                    <input type="text" placeholder="Search" className="EmpList-search-input"
                    onChange={(e) => setSearchData(e.target.value)}/>
                  </div>

                    {/* <input
                      placeholder="Search Here"
                      type="text"
                      className="form-control fs-small mb-2"
                      onChange={(e) => setSearchData(e.target.value)}
                    /> */}
                  </div>
                </div>
                <div className={Open?"table scroll":"table scroll"} style={{height:"auto"}}>
                {/* <table class="table "> */}
                <table className="shadow-sm min-w-full bg-white rounded-sm border border-gray-300 text-xs ">
                  
                  <thead>
                    <tr className="bg-gray-200">
                      <th className="px-2 py-1 border font-normal">Si No</th>
                      <th className="px-2 py-1 border font-normal">Name</th>
                      <th className="px-2 py-1 border font-normal">Leave Category</th>
                      <th className="px-2 py-1 border font-normal">Application Date</th>
                      <th className="px-2 py-1 border font-normal">Leave From</th>
                      <th className="px-2 py-1 border font-normal">Leave To</th>
                      <th className="px-2 py-1 border font-normal">Total Days</th>
                     
                    
                  

                      {Open ? (
                        <>
                          {/* <th className="px-2 py-1 border">Approved By</td>
                          <th className="px-2 py-1 border">Approval Date</td>
                          <td>Rejoin Date</td> */}
                          
                          <th className="px-2 py-1 border font-normal">Serialcode</th>
                       
                        </>
                      ) : null}
                        <th className="px-2 py-1 border font-normal">Actions</th>
                     
                    </tr>
                      </thead>
                        <tbody>
                    {dataPendingrecords
                      ? dataPendingrecords?.map((d, i) => (
                          // <tr className="dataTr">
                          <tr className="">
                            <td className="px-2 py-1 border">{i + 1}</td>
                            <td className="px-2 py-1 border">{d.Name}</td>
                            <td className="px-2 py-1 border">{d.Leave_Category}</td>
                            <td className="px-2 py-1 border">{d.ApplicationDate}</td>
                            <td className="px-2 py-1 border">{d.FromDate}</td>
                            <td className="px-2 py-1 border">{d.ToDate}</td>
                            <td className="px-2 py-1 border">{d.Days}</td>
                            {/* <td><input type="text" className="form-control"/></td> */}
                            

                            {Open ? (
                              <>
                                {/* <td className="px-2 py-1 border">{d.ApprovedBy}</td> */}
                                {/* <td className="px-2 py-1 border">{d.ApprovalDate}</td>
                                <td className="px-2 py-1 border">{d.RejoinDate}</td> */}
                                <td className="px-2 py-1 border">{d.Serialcode}</td>
                              </>
                            ) : null}

                            <td className="px-2 py-1 border text-center">
                              {/* <button
                                // className="dash-btn"
                      className="bg-green-500 px-2 py-1 border rounded-lg text-white font-semibold"

                                data-bs-toggle="modal"
                                data-bs-target="#exampleModal"
                                onClick={() => setPopUpData(d)}
                              >
                                Approve
                              </button> */}


                              <button
  className="bg-green-500 hover:bg-green-600 px-3 py-1.5 rounded-lg text-white font-semibold shadow-sm transition-all duration-200"
  onClick={() => {
    setPopUpData(d);
    setIsModalOpen(true); // replace Bootstrap modal with your Tailwind/React modal handler
  }}
>
  Approve
</button>
                            </td>
                          </tr>
                        ))
                      : null}
                  </tbody>
                </table>
                </div>
                {
          dataPendingrecords ?(<>
           <div className="pagination-div">
          <div className="text-end">
             <nav aria-label="Page navigation example">
                <ul class="pagination">
                  <li class="page-item">
                  {
                      currentPage !== 1 ? (
                    <button class="page-link" href="#" onClick={prePage}>
                      Previous
                    </button>
                      ) : ''
                    }
                  </li>
                  {numbers.map((n, i) => (
                    <li
                      className={`page-item ${
                        currentPage === n ? "active" : ""
                      }`}
                      key={i}
                    >
                      <button
                        className="page-link"
                        onClick={() => changeCPage(n)}
                        href="#"
                      >
                        {n}
                      </button>
                    </li>
                  ))}

                  <li class="page-item">
                  {
                    currentPage !== numbers[numbers.length - 1] ? (
                      <button class="page-link" href="#" onClick={nextPage}>
                        Next
                      </button>
                    ) : null
                  }
                  </li>
                </ul>
              </nav>
             </div>
          </div>
          </>):null
        }
          
              </div>

              <ul class="nav nav-tabs" id="myTab" role="tablist">
                <li class="nav-item" role="presentation">
                  <button
                    class="nav-link fs-small text-secondary active"
                    id="home-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#home-tab-pane"
                    type="button"
                    role="tab"
                    aria-controls="home-tab-pane"
                    aria-selected="true"
                  >
                    Leave Approved List
                  </button>
                </li>
                <li class="nav-item" role="presentation">
                  <button
                    class="nav-link fs-small text-secondary"
                    id="profile-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#profile-tab-pane"
                    type="button"
                    role="tab"
                    aria-controls="profile-tab-pane"
                    aria-selected="false"
                  >
                    Leave Rejected List
                  </button>
                </li>
                {/* <li class="nav-item" role="presentation">
              <button class="nav-link" id="contact-tab" data-bs-toggle="tab" data-bs-target="#contact-tab-pane" type="button" role="tab" aria-controls="contact-tab-pane" aria-selected="false">Contact</button>
            </li>
            <li class="nav-item" role="presentation">
              <button class="nav-link" id="disabled-tab" data-bs-toggle="tab" data-bs-target="#disabled-tab-pane" type="button" role="tab" aria-controls="disabled-tab-pane" aria-selected="false" disabled>Disabled</button>
            </li> */}
              </ul>
              <div class="tab-content" id="myTabContent">
              <div
                  class="tab-pane fade"
                  id="profile-tab-pane"
                  role="tabpanel"
                  aria-labelledby="profile-tab"
                  tabindex="0"
                >
                            <div className="leave-application-table mt-4 container scroll" style={{height:"auto",maxHeight:"250px"}}>
                    {/* <p className="fs-small text-secondary">Leave Approved List</p> */}
                    <div className="row">
                      <div className="col-3">

                      <div className="EmpList-search-container mb-4">
                        <FaSearch className="EmpList-search-icon" />
                        <input type="text" placeholder="Search" className="EmpList-search-input"
                          onChange={(e) =>
                            setSearchDataRejected(e.target.value)
                          }/>
                      </div>

                        {/* <input
                          type="text"
                          className="form-control fs-small mb-2"
                          placeholder="Search Here"
                          onChange={(e) =>
                            setSearchDataRejected(e.target.value)
                          }
                        /> */}
                      </div>
                    </div>
                    {/* <table class="table" */}
        <table className="mt-4 shadow-sm min-w-full bg-white rounded-sm border border-gray-300 text-xs ">

                      <thead>
                        <tr className="bg-gray-200">
                          <th className="px-2 py-1 border font-normal">Si No</th>
                          <th className="px-2 py-1 border font-normal">Name</th>
                          <th className="px-2 py-1 border font-normal">Leave Category</th>
                          <th className="px-2 py-1 border font-normal">Application Date</th>
                          <th className="px-2 py-1 border font-normal">Leave From</th>
                          <th className="px-2 py-1 border font-normal">Leave To</th>
                          <th className="px-2 py-1 border font-normal">Total Days</th>
                          <th className="px-2 py-1 border font-normal">Notes</th>
                          <th className="px-2 py-1 border font-normal">Ticket Status</th>
                          <th className="px-2 py-1 border font-normal">Approval Status</th>
                        </tr>
          </thead>
          <tbody>
                        {dataRejectedrecords
                          ? dataRejectedrecords?.map((d, i) => (
                              <tr className="dataTr">
                                <td className="px-2 py-1 border">{i + 1}</td>
                                <td className="px-2 py-1 border">{d.Name}</td>
                                <td className="px-2 py-1 border">{d.Leave_Category}</td>
                                <td className="px-2 py-1 border">{d.ApplicationDate}</td>
                                <td className="px-2 py-1 border">{d.FromDate}</td>
                                <td className="px-2 py-1 border">{d.ToDate}</td>
                                <td className="px-2 py-1 border">{d.Days}</td>
                                <td className="px-2 py-1 border">{d.approvalnote}</td>
                                {/* <td className="px-2 py-1 border"><input type="text" className="form-control"/></td> */}
                                <td className="px-2 py-1 border">{d.Ticket}</td>
                                <td className="px-2 py-1 border">{d.ApprovalStatus}</td>
                              </tr>
                            ))
                          : null}
                      </tbody>
                    </table>
                  </div>
                  {
          dataRejectedrecords ?(<>
           <div className="pagination-div">
          <div className="text-end">
             <nav aria-label="Page navigation example">
                <ul class="pagination">
                  <li class="page-item">
                    {
                      currentPageRejected !== 1 ? (
                    <button class="page-link" href="#" onClick={prePageRejected}>
                      Previous
                    </button>
                      ) : ''
                    }
                  </li>
                  {numbersRejected.map((n, i) => (
                    <li
                      className={`page-item ${
                        currentPageRejected === n ? "active" : ""
                      }`}
                      key={i}
                    >
                      <button
                        className="page-link"
                        onClick={() => changeCPageRejected(n)}
                        href="#"
                      >
                        {n}
                      </button>
                    </li>
                  ))}

                  <li class="page-item">
                    {
                      currentPageRejected !== numbersRejected[numbersRejected.length - 1] ? (
                    <button class="page-link" href="#" onClick={nextPageRejected}>
                      Next
                    </button>
                      ) : ""
                    }
                  </li>
                </ul>
              </nav>
             </div>
          </div>
          </>):null
        }
              
                </div>
                <div
                  class="tab-pane fade show active"
                  id="home-tab-pane"
                  role="tabpanel"
                  aria-labelledby="home-tab"
                  tabindex="0"
                >
                     <div className="leave-application-table mt-4 container scroll" style={{height:"auto",maxHeight:"250px"}}>
                    {/* <p className="fs-small text-secondary">Leave Rejected List</p> */}
                    <div className="row">
                      <div className="col-3">

                      <div className="EmpList-search-container">
                        <FaSearch className="EmpList-search-icon" />
                        <input type="text" placeholder="Search" className="EmpList-search-input"
                          onChange={(e) =>
                            setSearchDataApproved(e.target.value)
                          }/>
                      </div>

                        {/* <input
                          type="text"
                          className="form-control fs-small mb-2"
                          placeholder="Search Here"
                          onChange={(e) =>
                            setSearchDataApproved(e.target.value)
                          }
                        /> */}
                      </div>
                    </div>
                    {/* <table class="table"> */}
                            <table className="mt-4 shadow-sm min-w-full bg-white rounded-sm border border-gray-300 text-xs ">
          <thead>

                        <tr className="bg-gray-200">
                          <th className="px-2 py-1 border font-normal">Si No</th>
                          <th className="px-2 py-1 border font-normal">Name</th>
                          <th className="px-2 py-1 border font-normal">Leave Category</th>
                          <th className="px-2 py-1 border font-normal">Application Date</th>
                          <th className="px-2 py-1 border font-normal">Leave From</th>
                          <th className="px-2 py-1 border font-normal">Leave To</th>
                          <th className="px-2 py-1 border font-normal">Total Days</th>
                          <th className="px-2 py-1 border font-normal">Notes</th>
                          <th className="px-2 py-1 border font-normal">Ticket Status</th>
                          <th className="px-2 py-1 border font-normal">Approval Status</th>
                        </tr>
          </thead>

                      <tbody>
                        {dataApprovedrecords
                          ? dataApprovedrecords?.map((d, i) => (
                              <tr className="dataTr">
                                <td className="px-2 py-1 border">{i + 1}</td>
                                <td className="px-2 py-1 border">{d.Name}</td>
                                <td className="px-2 py-1 border">{d.Leave_Category}</td>
                                <td className="px-2 py-1 border">{d.ApplicationDate}</td>
                                <td className="px-2 py-1 border">{d.FromDate}</td>
                                <td className="px-2 py-1 border">{d.ToDate}</td>
                                <td className="px-2 py-1 border">{d.Days}</td>
                                <td className="px-2 py-1 border">{d.approvalnote}</td>
                                {/* <td className="px-2 py-1 border"><input type="text" className="form-control"/></td> */}
                                <td className="px-2 py-1 border">{d.Ticket}</td>
                                <td className="px-2 py-1 border">{d.ApprovalStatus}</td>
                              </tr>
                            ))
                          : null}
                      </tbody>
                    </table>
                  </div>
                  {
          dataApprovedrecords ?(<>
           <div className="pagination-div">
          <div className="text-end">
             <nav aria-label="Page navigation example">
                <ul class="pagination">
                  <li class="page-item">
                  {
                      currentPageApproved !== 1 ? (
                    <button class="page-link" href="#" onClick={prePageApproved}>
                      Previous
                    </button>
                      ) : ''
                    }
                  </li>
                  {numbersApproved.map((n, i) => (
                    <li
                      className={`page-item ${
                        currentPageApproved === n ? "active" : ""
                      }`}
                      key={i}
                    >
                      <button
                        className="page-link"
                        onClick={() => changeCPageApproved(n)}
                        href="#"
                      >
                        {n}
                      </button>
                    </li>
                  ))}

                  <li class="page-item">
                  {
                      currentPageApproved !== numbersApproved[numbersApproved.length - 1] ? (
                    <button class="page-link" href="#" onClick={nextPageApproved}>
                      Next
                    </button>
                      ) : ""
                    }
                  </li>
                </ul>
              </nav>
             </div>
          </div>
          </>):null
        }
                </div>
              
                {/* <div class="tab-pane fade" id="contact-tab-pane" role="tabpanel" aria-labelledby="contact-tab" tabindex="0">...</div>
            <div class="tab-pane fade" id="disabled-tab-pane" role="tabpanel" aria-labelledby="disabled-tab" tabindex="0">...</div> */}
              </div>
            </div>
          </>
        ) : null}
        
      </div>
      {isModalOpen &&

        <ApprovePopup setIsModalOpen={setIsModalOpen} setPopUpData={setPopUpData} PopUpData={PopUpData} reloadApi={reloadApi} setReloadApi={setReloadApi}/>
      }
      <div className="table-nodata-img mtd">
        {loader ? (
          <>
            {" "}
            <div className="table-nodata-img">
              <div className="center">
                <p className="text-center pt-5">
                  Please Wait Loading Data... &nbsp;
                  <FallingLines />
                </p>
              </div>
            </div>
          </>
        ) : null}
      </div>
    </div>
  );

  // pending
  function prePage() {
    if (currentPage !== firstIndex) {
      SetcurrentPage(currentPage - 1);
    }
  }

  function changeCPage(id) {
    SetcurrentPage(id);
  }

  function nextPage() {
    if (currentPage !== lastIndex) {
      SetcurrentPage(currentPage + 1);
    }
  }

  // approved
  function prePageApproved() {
    if (currentPageApproved !== firstIndexApproved) {
      SetcurrentPageApproved(currentPageApproved - 1);
    }
  }

  function changeCPageApproved(id) {
    SetcurrentPageApproved(id);
  }

  function nextPageApproved() {
    if (currentPageApproved !== lastIndexApproved) {
      SetcurrentPageApproved(currentPageApproved + 1);
    }
  }

  // rejected
  function prePageRejected() {
    if (currentPageRejected !== firstIndexRejected) {
      SetcurrentPageRejected(currentPageRejected - 1);
    }
  }

  function changeCPageRejected(id) {
    SetcurrentPageRejected(id);
  }

  function nextPageRejected() {
    if (currentPageRejected !== lastIndexRejected) {
      SetcurrentPageRejected(currentPageRejected + 1);
    }
  }

};

export default LeaveApproval;
